import React from 'react';
import loading from './loading.svg';
import {compose} from 'redux';
import {withStyles} from '@material-ui/core';

const style = {
    root: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
    },
    img: {
        width: '120px',
        height: 'auto',
    }
};

const CallbackSpinner = ({classes}) => (
    <div className={classes.root}>
        <img src={loading} alt="loading" className={classes.img}/>
    </div>
);

export default compose(withStyles(style))(CallbackSpinner);
